import { Agreement, AgreementCharge, Charge } from 'services/resources';

export const ADD_FILTER = 'app/services/Agreements/ADD_FILTER';
export const AGREEMENT_MANUAL_NOTIFIED_FAIL = 'app/services/Agreement/AGREEMENT_MANUAL_NOTIFIED_FAIL';
export const AGREEMENT_MANUAL_NOTIFIED_SUCCESS = 'app/services/Agreement/AGREEMENT_MANUAL_NOTIFIED_SUCCESS';
export const AGREEMENT_NOTIFICATION_FAIL = 'app/services/Agreement/AGREEMENT_NOTIFICATION_FAIL';
export const AGREEMENT_NOTIFICATION_SUCCESS = 'app/services/Agreement/AGREEMENT_NOTIFICATION_SUCCESS';
export const CHANGE_PER_PAGE_VALUE = 'app/services/Agreements/CHANGE_PER_PAGE_VALUE';
export const CHARGE_AGREEMENT_CUSTOMER_FAIL = 'app/services/Customers/CHARGE_AGREEMENT_CUSTOMER_FAIL';
export const MARK_AS_PAID_AGREEMENT_CUSTOMER_FAIL = 'app/services/Customers/MARK_AS_PAID_AGREEMENT_CUSTOMER_FAIL';
export const CHARGE_AGREEMENT_CUSTOMER_SUCCESS = 'app/services/Customers/CHARGE_AGREEMENT_CUSTOMER_SUCCESS';
export const MARK_AS_PAID_AGREEMENT_CUSTOMER_SUCCESS = 'app/services/Customers/MARK_AS_PAID_AGREEMENT_CUSTOMER_SUCCESS';
export const CLEAR_AGREEMENT = 'app/services/Agreements/CLEAR_AGREEMENT';
export const CLEAR_FILTERS = 'app/services/Agreements/CLEAR_FILTERS';
export const CLEAR_NOTIFICATIONS = 'app/services/Agreements/CLEAR_NOTIFICATIONS';
export const CLEAR_VEHICLE = 'app/services/Agreements/CLEAR_VEHICLE';
export const CREATE_AGREEMENT_FAIL = 'app/services/Agreements/CREATE_AGREEMENT_FAIL';
export const CREATE_AGREEMENT_SUCCESS = 'app/services/Agreements/CREATE_AGREEMENT_SUCCESS';
export const DELETE_AGREEMENT_FAIL = 'app/services/Agreements/DELETE_AGREEMENT_FAIL';
export const DELETE_AGREEMENT_SUCCESS = 'app/services/Agreements/DELETE_AGREEMENT_SUCCESS';
export const GET_AGREEMENT_FAIL = 'app/services/Agreements/GET_AGREEMENT_FAIL';
export const GET_AGREEMENT_HTML = 'app/services/Agreement/GET_AGREEMENT_HTML';
export const GET_AGREEMENT_SUCCESS = 'app/services/Agreements/GET_AGREEMENT_SUCCESS';
export const GET_AGREEMENTS_FAIL = 'app/services/Agreements/GET_AGREEMENTS_FAIL';
export const GET_AGREEMENTS_SUCCESS = 'app/services/Agreements/GET_AGREEMENTS_SUCCESS';
export const GET_AGREEMENT_VEHICLE_SUCCESS = 'app/services/Agreements/GET_AGREEMENT_VEHICLE_SUCCESS';
export const GET_AGREEMENT_VEHICLE_FAIL = 'app/services/Agreements/GET_AGREEMENT_VEHICLE_FAIL';
export const GET_CONTACTLESS_AGREEMENT_FAIL = 'app/services/Agreements/GET_CONTACTLESS_AGREEMENT_FAIL';
export const GET_CONTACTLESS_AGREEMENT_SUCCESS = 'app/services/Agreements/GET_CONTACTLESS_AGREEMENT_SUCCESS';
export const GET_INSPECTION_IN = 'app/services/Agreements/GET_INSPECTION_IN';
export const GET_INSPECTION_OUT = 'app/services/Agreements/GET_INSPECTION_OUT';
export const PREVIEW_AGREEMENT_CHARGE_CALCULATIONS_FAIL =
  'app/services/Agreements/PREVIEW_AGREEMENT_CHARGE_CALCULATIONS_FAIL';
export const PREVIEW_AGREEMENT_CHARGE_CALCULATIONS_SUCCESS =
  'app/services/Agreements/PREVIEW_AGREEMENT_CHARGE_CALCULATIONS_SUCCESS';
export const REFRESH_FIELD_FAIL = 'app/services/Agreement/REFRESH_FIELD_FAIL';
export const REFRESH_FIELD_SUCCESS = 'app/services/Agreement/REFRESH_FIELD_SUCCESS';
export const REFRESH_FUEL_IN_SUCCESS = 'app/services/Agreement/REFRESH_FUEL_IN_SUCCESS';
export const REFRESH_FUEL_OUT_SUCCESS = 'app/services/Agreement/REFRESH_FUEL_OUT_SUCCESS';
export const REFRESH_FUEL_SUCCESS = 'app/services/Agreement/REFRESH_FUEL_SUCCESS';
export const REFRESH_BATTERY_SUCCESS = 'app/services/Agreement/REFRESH_BATTERY_SUCCESS';
export const REFRESH_ODOMETER_IN_SUCCESS = 'app/services/Agreement/REFRESH_ODOMETER_IN_SUCCESS';
export const REFRESH_ODOMETER_OUT_SUCCESS = 'app/services/Agreement/REFRESH_ODOMETER_OUT_SUCCESS';
export const REFRESH_ODOMETER_SUCCESS = 'app/services/Agreement/REFRESH_ODOMETER_SUCCESS';
export const REMOVE_FILTER = 'app/services/Agreements/REMOVE_FILTER';
export const RESET_AGREEMENTS_DATA = 'app/services/Agreements/RESET_AGREEMENTS_DATA';
export const SELECT_VIEW = 'app/services/Agreements/SELECT_VIEW';
export const SET_FILTERS = 'app/services/Agreements/SET_FILTERS';
export const SEND_COPY_FAIL = 'app/services/Agreement/SEND_COPY_FAIL';
export const SEND_COPY_SUCCESS = 'app/services/Agreement/SEND_COPY_SUCCESS';
export const SEND_FOR_SIGNATURE_FAIL = 'app/services/Agreement/SEND_FOR_SIGNATURE_FAIL';
export const SEND_FOR_SIGNATURE_SUCCESS = 'app/services/Agreement/SEND_FOR_SIGNATURE_SUCCESS';
export const SET_AGREEMENT = 'app/services/Agreements/SET_AGREEMENT';
export const SET_AGREEMENTS_OFFSET = 'app/services/Agreements/SET_AGREEMENTS_OFFSET';
export const SET_COLUMNS = 'app/services/Agreements/SET_COLUMNS';
export const SET_INSPECTION_IN = 'app/services/Agreements/SET_INSPECTION_IN';
export const SET_INSPECTION_OUT = 'app/services/Agreements/SET_INSPECTION_OUT';
export const SET_SEARCH_QUERY = 'app/services/Agreements/SET_SEARCH_QUERY';
export const SET_VEHICLE = 'app/services/Agreements/SET_VEHICLE';
export const START_LOADING = 'app/services/Agreements/START_LOADING';
export const START_AGREEMENTS_REQUEST = 'app/services/Agreements/START_AGREEMENTS_REQUEST';
export const STOP_LOADING = 'app/services/Agreements/STOP_LOADING';
export const UPDATE_AGREEMENT_FAIL = 'app/services/Agreements/UPDATE_AGREEMENT_FAIL';
export const UPDATE_AGREEMENT_SUCCESS = 'app/services/Agreements/UPDATE_AGREEMENT_SUCCESS';
export const UPDATE_AGREEMENT_SUCCESS_SILENT = 'app/services/Agreements/UPDATE_AGREEMENT_SUCCESS_SILENT';
export const UPDATE_CC_FAIL = 'app/services/Customers/UPDATE_CC_FAIL';
export const UPDATE_CC_SUCCESS = 'app/services/Customers/UPDATE_CC_SUCCESS';
export const UPDATE_INSPECTION_FAIL = 'app/services/Agreements/UPDATE_INSPECTION_FAIL';
export const UPDATE_INSPECTION_SUCCESS = 'app/services/Agreements/UPDATE_INSPECTION_SUCCESS';
export const UPDATE_SIGNATURE_FAIL = 'app/services/Agreement/UPDATE_SIGNATURE_FAIL';
export const UPDATE_SIGNATURE_SUCCESS = 'app/services/Agreement/UPDATE_SIGNATURE_SUCCESS';

// Agreement Charges
export const GET_AGREEMENT_CHARGE_FAIL = 'app/services/Agreements/GET_AGREEMENT_CHARGE_FAIL';
export const GET_AGREEMENT_CHARGE_SUCCESS = 'app/services/Agreements/GET_AGREEMENT_CHARGE_SUCCESS';
export const LIST_AGREEMENT_CHARGE_FAIL = 'app/services/Agreements/LIST_AGREEMENT_CHARGE_FAIL';
export const LIST_AGREEMENT_CHARGE_SUCCESS = 'app/services/Agreements/LIST_AGREEMENT_CHARGE_SUCCESS';
export const CREATE_AGREEMENT_CHARGE_FAIL = 'app/services/Agreements/CREATE_AGREEMENT_CHARGE_FAIL';
export const CREATE_AGREEMENT_CHARGE_SUCCESS = 'app/services/Agreements/CREATE_AGREEMENT_CHARGE_SUCCESS';
export const DELETE_AGREEMENT_CHARGE_FAIL = 'app/services/Agreements/DELETE_AGREEMENT_CHARGE_FAIL';
export const DELETE_AGREEMENT_CHARGE_SUCCESS = 'app/services/Agreements/DELETE_AGREEMENT_CHARGE_SUCCESS';
export const UPDATE_AGREEMENT_CHARGE_FAIL = 'app/services/Agreements/UPDATE_AGREEMENT_CHARGE_FAIL';
export const UPDATE_AGREEMENT_CHARGE_SUCCESS = 'app/services/Agreements/UPDATE_AGREEMENT_CHARGE_SUCCESS';
export const DELETE_AGREEMENT_CHARGES_FAIL = 'app/services/Agreements/DELETE_AGREEMENT_CHARGES_FAIL';
export const DELETE_AGREEMENT_CHARGES_SUCCESS = 'app/services/Agreements/DELETE_AGREEMENT_CHARGES_SUCCESS';
export const UPDATE_AGREEMENT_CHARGES_FAIL = 'app/services/Agreements/UPDATE_AGREEMENT_CHARGES_FAIL';
export const UPDATE_AGREEMENT_CHARGES_SUCCESS = 'app/services/Agreements/UPDATE_AGREEMENT_CHARGES_SUCCESS';

// Agreement Damage and Pictures
export const ADD_DAMAGE_FAIL = 'app/sevices/Agreement/ADD_DAMAGE_FAIL';
export const UPDATE_DAMAGE_FAIL = 'app/sevices/Agreement/UPDATE_DAMAGE_FAIL';
export const DELETE_DAMAGE_FAIL = 'app/sevices/Agreement/DELETE_DAMAGE_FAIL';
export const ADD_DAMAGE_PICTURE_FAIL = 'app/sevices/Agreement/ADD_DAMAGE_PICTURE_FAIL';
export const DELETE_DAMAGE_PICTURE_FAIL = 'app/sevices/Agreement/DELETE_DAMAGE_PICTURE_FAIL';

export const GET_GEOFENCE_ALERTS_SUCCESS = 'app/services/FleetSettings/GET_GEOFENCE_ALERTS_SUCCESS';
export const GET_GEOFENCE_ALERTS_FAIL = 'app/services/FleetSettings/GET_GEOFENCE_ALERTS_FAIL';
export const CLEAR_VIOLATIONS = 'app/services/Agreements/CLEAR_VIOLATIONS';

export const startLoading = () => ({
  type: START_LOADING,
});

export const startAgreementsRequest = (requestId) => ({
  type: START_AGREEMENTS_REQUEST,
  payload: { requestId },
});

export const stopLoading = () => ({
  type: STOP_LOADING,
});

export const receivedSelectedView = (view) => ({
  type: SELECT_VIEW,
  payload: { view },
});

export const setFilters = (filters) => ({
  type: SET_FILTERS,
  payload: { filters },
});

export const receivedNewFilter = (filter) => ({
  type: ADD_FILTER,
  payload: { filter },
});

export const receivedRemoveFilter = (index) => ({
  type: REMOVE_FILTER,
  payload: { index },
});

export const receivedClearFilters = () => ({
  type: CLEAR_FILTERS,
});

export const receivedClearAgreement = () => ({
  type: CLEAR_AGREEMENT,
});

export const receivedSetSearchQuery = (searchQuery) => ({
  type: SET_SEARCH_QUERY,
  payload: { searchQuery },
});

export const receivedSetAgreement = (agreement) => ({
  type: SET_AGREEMENT,
  payload: { agreement },
});

export const receivedSetInspectionOut = (inspection) => ({
  type: SET_INSPECTION_OUT,
  payload: { inspection },
});

export const receivedSetInspectionIn = (inspection) => ({
  type: SET_INSPECTION_IN,
  payload: { inspection },
});

export const receivedGetInspectionOut = (inspection) => ({
  type: GET_INSPECTION_OUT,
  payload: { inspection },
});

export const receivedGetInspectionIn = (inspection) => ({
  type: GET_INSPECTION_IN,
  payload: { inspection },
});

export const receivedUpdateInspectionSuccess = (inspection) => ({
  type: UPDATE_INSPECTION_SUCCESS,
  payload: { inspection },
});

export const receivedUpdateInspectionFail = (errors) => ({
  type: UPDATE_INSPECTION_FAIL,
  payload: { errors },
});

export const receivedSetVehicle = (vehicle) => ({
  type: SET_VEHICLE,
  payload: { vehicle },
});

export const receivedSetColumns = (columns) => ({
  type: SET_COLUMNS,
  payload: { columns },
});

export const receivedAgreementHTML = (html) => ({
  type: GET_AGREEMENT_HTML,
  payload: { html },
});

export const sendCopySuccess = () => ({
  type: SEND_COPY_SUCCESS,
  payload: {},
});

export const sendCopyFail = () => ({
  type: SEND_COPY_FAIL,
  payload: {},
});

export const sendForSignatureFail = () => ({
  type: SEND_FOR_SIGNATURE_FAIL,
  payload: {},
});

export const sendForSignatureSuccess = (agreement) => ({
  type: SEND_FOR_SIGNATURE_SUCCESS,
  payload: { agreement },
});

export const receivedResetAgreements = () => ({
  type: RESET_AGREEMENTS_DATA,
});

export const receivedAgreementsOffset = (offset) => ({
  type: SET_AGREEMENTS_OFFSET,
  payload: { offset },
});

export const receivedAgreementsSuccess = (data, offset, requestId) => ({
  type: GET_AGREEMENTS_SUCCESS,
  payload: {
    data,
    offset,
    requestId,
  },
});

export const receivedAgreementsFail = (errors, requestId) => ({
  type: GET_AGREEMENTS_FAIL,
  payload: { errors, requestId },
});

export const receivedPerPageValue = (perPage) => ({
  type: CHANGE_PER_PAGE_VALUE,
  payload: { perPage },
});

export const receivedAgreementSuccess = (agreement) => ({
  type: GET_AGREEMENT_SUCCESS,
  payload: { agreement },
});

export const receivedAgreementFail = (errors) => ({
  type: GET_AGREEMENT_FAIL,
  payload: { errors },
});

export const receivedAgreementVehicleSuccess = (vehicle) => ({
  type: GET_AGREEMENT_VEHICLE_SUCCESS,
  payload: { vehicle },
});

export const receivedAgreementVehicleFail = (errors) => ({
  type: GET_AGREEMENT_VEHICLE_FAIL,
  payload: { errors },
});

export const receivedContactlessAgreementSuccess = (agreement) => ({
  type: GET_CONTACTLESS_AGREEMENT_SUCCESS,
  payload: { agreement },
});

export const receivedContactlessAgreementFail = (errors) => ({
  type: GET_CONTACTLESS_AGREEMENT_FAIL,
  payload: { errors },
});

export const receivedDeleteAgreementSuccess = (agreementId) => ({
  type: DELETE_AGREEMENT_SUCCESS,
  payload: { agreementId },
});
export const receivedDeleteAgreementFail = (errors) => ({
  type: DELETE_AGREEMENT_FAIL,
  payload: { errors },
});

export const receivedCreateAgreementSuccess = (agreement) => ({
  type: CREATE_AGREEMENT_SUCCESS,
  payload: { agreement },
});

export const receivedCreateAgreementFail = (errors) => ({
  type: CREATE_AGREEMENT_FAIL,
  payload: { errors },
});

export const receivedUpdateAgreementChargesSuccess = (agreement) => ({
  type: UPDATE_AGREEMENT_CHARGES_SUCCESS,
  payload: { agreement },
});

export const receivedUpdateAgreementChargesFail = (errors) => ({
  type: UPDATE_AGREEMENT_CHARGES_FAIL,
  payload: { errors },
});

export const receivedUpdateAgreementSuccess = (
  { agreement, action },

  silent = false
) =>
  silent
    ? {
        type: UPDATE_AGREEMENT_SUCCESS_SILENT,
        payload: { agreement, action },
      }
    : {
        type: UPDATE_AGREEMENT_SUCCESS,
        payload: { agreement, action },
      };

export const receivedUpdateAgreementFail = (errors) => ({
  type: UPDATE_AGREEMENT_FAIL,
  payload: { errors },
});

export const receivedCreateAgreementChargeSuccess = (charge: AgreementCharge) => ({
  type: CREATE_AGREEMENT_CHARGE_SUCCESS,
  payload: { charge },
});

export const receivedCreateAgreementChargeFail = (errors) => ({
  type: CREATE_AGREEMENT_CHARGE_FAIL,
  payload: { errors },
});

export const receivedUpdateAgreementChargeSuccess = (charge: AgreementCharge) => ({
  type: UPDATE_AGREEMENT_CHARGE_SUCCESS,
  payload: { charge },
});

export const receivedUpdateAgreementChargeFail = (errors) => ({
  type: UPDATE_AGREEMENT_CHARGE_FAIL,
  payload: { errors },
});

export const receivedPreviewChargeCalculationsSuccess = (calculations) => ({
  type: PREVIEW_AGREEMENT_CHARGE_CALCULATIONS_SUCCESS,
  payload: { calculations },
});

export const receivedPreviewChargeCalculationsFail = (errors) => ({
  type: PREVIEW_AGREEMENT_CHARGE_CALCULATIONS_FAIL,
  payload: { errors },
});

export const receivedDeleteAgreementChargeSuccess = (chargeId: number) => ({
  type: DELETE_AGREEMENT_CHARGE_SUCCESS,
  payload: { chargeId },
});

export const receivedDeleteAgreementChargeFail = (errors) => ({
  type: DELETE_AGREEMENT_CHARGE_FAIL,
  payload: { errors },
});

export const receivedDeleteAgreementChargesSuccess = (agreement) => ({
  type: DELETE_AGREEMENT_CHARGES_SUCCESS,
  payload: { agreement },
});

export const receivedDeleteAgreementChargesFail = (errors) => ({
  type: DELETE_AGREEMENT_CHARGES_FAIL,
  payload: { errors },
});

export const receivedClearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
});

export const receivedUpdateCCSuccess = (agreement) => ({
  type: UPDATE_CC_SUCCESS,
  payload: { agreement },
});

export const receivedUpdateCCFail = (errors) => ({
  type: UPDATE_CC_FAIL,
  payload: { errors },
});

export const receivedChargeAgreementCustomerSuccess = (agreement: Agreement) => ({
  type: CHARGE_AGREEMENT_CUSTOMER_SUCCESS,
  payload: { agreement },
});

export const receivedMarkAsPaidAgreementCustomerSuccess = (agreement: Agreement) => ({
  type: MARK_AS_PAID_AGREEMENT_CUSTOMER_SUCCESS,
  payload: { agreement },
});

export const receivedChargeAgreementCustomerFail = (errors) => ({
  type: CHARGE_AGREEMENT_CUSTOMER_FAIL,
  payload: { errors },
});

export const receivedMarkAsPaidAgreementCustomerFail = (errors) => ({
  type: MARK_AS_PAID_AGREEMENT_CUSTOMER_FAIL,
  payload: { errors },
});

export const receivedAgreementNotificationSuccess = (agreement) => ({
  type: AGREEMENT_NOTIFICATION_SUCCESS,
  payload: { agreement },
});

export const receivedAgreementNotificationFail = (errors) => ({
  type: AGREEMENT_NOTIFICATION_FAIL,
  payload: { errors },
});

export const receivedAgreementManualNotifiedSuccess = (agreement) => ({
  type: AGREEMENT_MANUAL_NOTIFIED_SUCCESS,
  payload: { agreement },
});

export const receivedAgreementManualNotifiedFail = (errors) => ({
  type: AGREEMENT_MANUAL_NOTIFIED_FAIL,
  payload: { errors },
});

export const receivedRefreshFuelSuccess = (vehicle) => ({
  type: REFRESH_FUEL_SUCCESS,
  payload: {
    connectedFuelLevel: vehicle.connectedFuelLevel,
    fuelLevel: vehicle.fuelLevel,
    fuelLevelDate: vehicle.fuelLevelDate,
    fuelLevelStale: vehicle.fuelLevelStale,
    isConnected: vehicle.isConnected,
  },
});

export const receivedRefreshBatterySuccess = (vehicle) => ({
  type: REFRESH_BATTERY_SUCCESS,
  payload: {
    connectedBatteryLevel: vehicle.connectedBatteryLevel,
    batteryLevel: vehicle.batteryLevel,
    batteryLevelDate: vehicle.batteryLevelDate,
    isConnected: vehicle.isConnected,
  },
});

export const receivedRefreshFieldFail = (errors) => ({
  type: REFRESH_FIELD_FAIL,
  payload: { errors },
});

export const receivedRefreshFieldSuccess = (agreement) => ({
  type: REFRESH_FIELD_SUCCESS,
  payload: { agreement },
});

export const receivedRefreshOdometerSuccess = (vehicle) => ({
  type: REFRESH_ODOMETER_SUCCESS,
  payload: {
    odometer: vehicle.odometer,
    connectedOdometer: vehicle.connectedOdometer,
    mileageCalculated: vehicle.mileageCalculated,
    mileageCalculatedDate: vehicle.mileageCalculatedDate,
    odometerInitial: vehicle.odometerInitial,
    odometerInitialDate: vehicle.odometerInitialDate,
    odometerStale: vehicle.odometerStale,
    isConnected: vehicle.isConnected,
  },
});

export const receivedUpdateSignatureSuccess = () => ({
  type: UPDATE_SIGNATURE_SUCCESS,
});

export const receivedUpdateSignatureFail = (errors) => ({
  type: UPDATE_SIGNATURE_FAIL,
  payload: { errors },
});

export const receivedAddDamageFail = (errors) => ({
  type: ADD_DAMAGE_FAIL,
  payload: { errors },
});

export const receivedUpdateDamageFail = (errors) => ({
  type: UPDATE_DAMAGE_FAIL,
  payload: { errors },
});

export const receivedRemoveDamageFail = (errors) => ({
  type: DELETE_DAMAGE_FAIL,
  payload: { errors },
});

export const receivedAddDamagePictureFail = (errors) => ({
  type: ADD_DAMAGE_PICTURE_FAIL,
  payload: { errors },
});

export const receivedRemoveDamagePictureFail = (errors) => ({
  type: DELETE_DAMAGE_PICTURE_FAIL,
  payload: { errors },
});

export const receivedGeofenceAlertsSuccess = (data) => ({
  type: GET_GEOFENCE_ALERTS_SUCCESS,
  payload: { data },
});

export const receivedGeofenceAlertsFail = (errors) => ({
  type: GET_GEOFENCE_ALERTS_FAIL,
  payload: { errors },
});

export const clearViolations = () => ({
  type: CLEAR_VIOLATIONS,
  payload: {},
});

export const clearVehicle = () => ({
  type: CLEAR_VEHICLE,
});
